import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Register } from './LoginForm';
import { TextP } from '../../..';
import { CheckBoxWrapper } from '../Category/ProductFilter';
import { DsiPreRegisterForm as PreRegisterForm } from './PreRegisterForm';
import { DsiEndRegisterForm as EndRegisterForm } from './EndRegisterForm';
import { DsiWarehouseRegisterForm as WarehouseRegisterForm } from './WarehouseRegisterForm';

interface Props {
  cartId: string | undefined;
  handleFormSubmit: any;
  handleGoogleLogin: any;
  isFetching: boolean;
  successMessage: string;
  errorMessage: string;
  lang: string;
  enableEndUser: boolean;
  enableWarehouse: boolean;
  showPreRegister: boolean;
  sendAsBody?: boolean;
}

function RegisterForm({
  cartId,
  handleFormSubmit,
  handleGoogleLogin,
  isFetching,
  successMessage,
  errorMessage,
  lang,
  enableEndUser,
  enableWarehouse,
  showPreRegister,
  sendAsBody
}: Props) {
  const [isPreRegisterVisible, setIsPreRegisterVisible] = React.useState(
    showPreRegister === false ? false : true,
  );
  const [isEndUser, setIsEndUser] = React.useState(
    enableEndUser ? true : false,
  );

  const handleEndUser = () => {
    setIsEndUser(!isEndUser);
  };

  const handleIsPreRegisterVisible = () => {
    setIsPreRegisterVisible(!isPreRegisterVisible);
  };

  return (
    <>
      {isPreRegisterVisible ? (
        <PreRegisterForm
          handleEndUser={handleEndUser}
          isEndUser={isEndUser}
          handleIsVisible={handleIsPreRegisterVisible}
          enableEndUser={enableEndUser}
          enableWarehouse={enableWarehouse}
        />
      ) : isEndUser ? (
        <EndRegisterForm
          cartId={cartId}
          handleFormSubmit={handleFormSubmit}
          handleGoogleLogin={handleGoogleLogin}
          isFetching={isFetching}
          successMessage={successMessage}
          errorMessage={errorMessage}
          // we send as body on dsi
          sendAsBody={sendAsBody?true:showPreRegister}
        />
      ) : (
        <WarehouseRegisterForm
          cartId={cartId}
          handleFormSubmit={handleFormSubmit}
          isFetching={isFetching}
          successMessage={successMessage}
          errorMessage={errorMessage}
          lang={lang}
        />
      )}
    </>
  );
}

export const Header = styled.h1`
  font-size: ${rem(30)};
  font-weight: 400;
  position: relative;
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(38)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Form = styled.form`
  margin: 0;
  & input:first-of-type {
    margin-bottom: ${rem(16)};
  }
`;

export const Required = styled(TextP)`
  color: rgba(255, 30, 69, 0.92);
`;

export const StyledCheckBoxWrapper = styled(CheckBoxWrapper)<{
  marginBottom?: number;
  marginTop?: number;
}>`
  margin: 0;
  margin-top: ${({ marginTop }) => (marginTop ? rem(marginTop) : rem(32))};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 0};
`;

export const StyledRegister = styled(Register)<{ selected: boolean }>`
  font-size: ${rem(16)};
  font-weight: ${({ selected }) => (selected ? '500' : '400')};
`;

export { RegisterForm as DsiRegisterForm };
